






import {Vue, Component, Prop, Watch, Mixins} from "vue-property-decorator";
import { Viewer } from '@toast-ui/vue-editor';
import ClipboardMixin from "../../mixins/ClipboardMixin";


interface Bookmark {
    title: string;
    hash: string;
}

@Component({
    components: {
        Viewer,
    }
})
export default class MarkdownViewer extends Mixins(ClipboardMixin) {
    @Prop()
    public value!: string;

    @Watch('value', {deep: true})
    public valueChange() {
        console.log(this.value);
        // @ts-ignore
        this.$refs.viewer.invoke('setMarkdown', this.value);
    }

}
